import React from 'react';
import { Package, Clock, MessageSquare } from 'lucide-react';

interface RareRequest {
    id: string;
    part_name: string;
    vehicle_model: string;
    status: 'PENDING' | 'QUOTED' | 'CLOSED';
    created_at: string;
    quote_count: number;
}

interface RequestsStatusBoardProps {
    requests: RareRequest[];
    onRefresh: () => void;
    onViewQuotes: (requestId: string) => void;
}

export const RequestsStatusBoard: React.FC<RequestsStatusBoardProps> = ({ requests, onRefresh, onViewQuotes }) => {
    if (requests.length === 0) return null;

    return (
        <div className="bg-charcoal-light/30 border border-white/5 rounded-3xl p-6 mt-6">
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-sm font-black text-white flex items-center gap-2">
                    <span className="material-symbols-outlined text-primary">analytics</span> متابعة القطع النادرة
                </h3>
                <button onClick={onRefresh} className="p-1 hover:rotate-180 transition-all duration-500 text-gray-500">
                    <span className="material-symbols-outlined text-sm">refresh</span>
                </button>
            </div>

            <div className="space-y-3">
                {requests.map((req) => (
                    <div key={req.id} className="bg-black/20 border border-white/5 rounded-2xl p-4 flex items-center justify-between group hover:border-primary/20 transition-all">
                        <div className="flex items-center gap-4">
                            <div className={`size-10 rounded-xl flex items-center justify-center ${req.status === 'QUOTED' ? 'bg-green-500/10 text-green-400' : 'bg-orange-500/10 text-orange-400'}`}>
                                <Package size={20} />
                            </div>
                            <div>
                                <h4 className="text-sm font-bold text-white">{req.part_name}</h4>
                                <div className="flex items-center gap-2 mt-1">
                                    <span className="text-[9px] text-gray-500 uppercase">{req.vehicle_model}</span>
                                    <span className="text-gray-700 text-[8px]">•</span>
                                    <span className="text-[9px] text-gray-500 flex items-center gap-1">
                                        <Clock size={10} /> {new Date(req.created_at).toLocaleDateString()}
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="flex items-center gap-3">
                            {req.status === 'QUOTED' ? (
                                <button
                                    onClick={() => onViewQuotes(req.id)}
                                    className="px-3 py-1.5 bg-green-500 text-background-dark text-[10px] font-black rounded-lg hover:scale-105 active:scale-95 transition-all flex items-center gap-1"
                                >
                                    وصلك عروض ({req.quote_count}) <MessageSquare size={12} />
                                </button>
                            ) : (
                                <div className="flex flex-col items-end gap-1">
                                    <span className="text-[9px] font-bold text-orange-400 uppercase tracking-tighter animate-pulse">جاري البحث...</span>
                                    <span className="text-[8px] text-gray-600">انتظر اشعار الواتساب</span>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
